import { dropZeroCents, formatAsCurrency, formatAsCurrencyOrZero } from '../../utils/priceTools'

export const commissionsPayoutMinimum = 200

export const commissionsCashBackPercent = 10

export const commissionsCashBack = (commissionsAmount: number) =>
  commissionsAmount * (commissionsCashBackPercent / 100)

export const getCommissionsBalanceAmounts = ({
  commissionsBalance,
}: {
  commissionsBalance: number
}) => {
  const isPayoutAvailable = commissionsBalance >= commissionsPayoutMinimum
  const remainingUntilAvailable = Math.max(0, commissionsPayoutMinimum - commissionsBalance)

  return {
    isPayoutAvailable: {
      value: isPayoutAvailable,
    },
    remaining: {
      value: remainingUntilAvailable,
      formatted: dropZeroCents(formatAsCurrencyOrZero({ amount: remainingUntilAvailable })),
    },
    minRedeemable: {
      value: commissionsPayoutMinimum,
      formatted: formatAsCurrency({ amount: commissionsPayoutMinimum, fractionDigits: 0 }) || '$0',
    },
    maxRedeemable: {
      value: commissionsBalance,
      formatted: formatAsCurrency({ amount: commissionsBalance }) || '$0',
    },
    balance: {
      value: commissionsBalance,
      formatted: dropZeroCents(formatAsCurrencyOrZero({ amount: commissionsBalance })),
    },
  }
}

export const calculateCashBackOnSpentCommissions = ({
  totalBalance,
  commissionsBalance,
  rebateAmount,
}: {
  totalBalance: number
  commissionsBalance: number
  rebateAmount: number
}) => {
  const rewardsAndCreditBalance = totalBalance - commissionsBalance
  const spentCommissions = rebateAmount - rewardsAndCreditBalance
  const spentCommissionsNonNegative = Math.max(spentCommissions, 0)
  return commissionsCashBack(spentCommissionsNonNegative)
}
